import React from 'react'
import AccountInvitationPanel from '../../AccountInvitationPanel'
import { runPlayerCommand } from '../playerCreationOperation'
import { invitationLabels } from '../playerInvitationState'

export default function PlayerInvitationPanel(props) {
  return <AccountInvitationPanel {...props} resource="player" accountName="Player" labels={invitationLabels} runCommand={runPlayerCommand} />
}
